/**
 * API Configuration - Loads directly from environment variables
 * NO extra config file needed!
 * 
 * How it works:
 * 1. .env files define REACT_APP_API and REACT_APP_PMS
 * 2. This file imports them directly
 * 3. No ENVIRONMENTS object, no extra logic
 */

export const getApiUrl = () => process.env.REACT_APP_API;
export const getPmsUrl = () => process.env.REACT_APP_PMS;

// Optional: Display loaded config in console
if (process.env.NODE_ENV === 'development') {
  console.log('✅ Configuration Loaded:', {
    env: process.env.REACT_APP_ENV,
    api: process.env.REACT_APP_API,
    pms: process.env.REACT_APP_PMS,
  });
}
